<template>
  <div class="externalInvoice">
    <table>
      <thead>
        <tr>
          <td>
            <div class="header">
              <div class="logo mb-1 flex align-center space-between">
                <img
                  v-if="prescriptionLogo"
                  :src="prescriptionLogo"
                  style="max-width: 15rem; min-height: 3rem; max-height :4rem ; min-width: 14rem;"
                  alt="logo"
                />
                <img
                  v-if="userInfo.tenantId !== 1 && getBranchUrl"
                  :src="getBranchUrl"
                  style="max-width: 15rem; min-height: 3rem; max-height :4rem ; min-width: 14rem;"
                  alt="logo"
                />
              </div>
              <div class="flex justify-center m-0" v-if="tokenNo !== '-'">
                <div class="token m-0" style="text-align: center">
                  <p class="m-o" style="font-size: 14pt; font-weight: 600">
                    {{ tokenServiceHeader }}
                  </p>
                  <p class="m-o" style="font-size: 12pt; font-weight: 600">
                    TOKEN NO : <strong>{{ tokenNo }}</strong>
                  </p>
                </div>
              </div>
              <div class="medical-record flex align-center space-between">
                <h2>Invoice No: {{ invoiceNo }}</h2>
                <h2>Date: {{ currentDate }}</h2>
              </div>
              <div
                class="
                  outpatient-details
                  flex
                  align-center
                  space-between
                  flex-wrap
                "
              >
                <div>
                  <h2>
                    Patient Name:
                    {{ patient.name || searchResult.name }} /
                    {{
                      patient.fatherOrHusbandName ||
                        searchResult.fatherOrHusbandName
                    }}
                  </h2>
                  <h2>
                    Address: {{ patient.address || searchResult.address }}
                  </h2>
                </div>
                <div>
                  <h2>Age: {{ patient.age || searchResult.age }}</h2>
                  <h2>MR: {{ patient.mr_no || searchResult.mr_no }}</h2>
                </div>
                <div>
                  <h2>
                    Sex:
                    {{
                      getGender(
                        patient.gender || searchResult.gender || patientGender
                      )
                    }}
                  </h2>
                  <h2 v-if="selectedDiscountType">
                    Panel : {{ selectedDiscountType }}
                  </h2>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </thead>
      <tbody class="table-body">
        <tr>
          <td class="flex">
            <div class="content">
              <h1>Chief Complaints</h1>
              <div class="flex treamtent-wrraper">
                <div class="treatment">
                  <h1>BP:</h1>
                  <h1>TEMP:</h1>
                  <h1>Weight:</h1>
                  <h1>Anaemia:</h1>
                  <h1>Examination</h1>
                  <h1 class="mt-1">Diagnosis</h1>
                  <h1>Referral:</h1>
                </div>
              </div>
            </div>
            <div class="content-space">
              <h1>Treatment</h1>
              <div class="flex treamtent-wrraper">
                <div class="treatment">
                  <h1>
                    Follow up:
                    {{ referredBy }}
                  </h1>
                  <h1>Counseled for: {{ doctor }}</h1>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <table>
          <td>
            <footer>
              <div class="message text-center">
                <p>
                  تولیدی صحت اور خاندانی منصوبہ بندی کی خدمات کے لئے رابطہ کیجئے
                </p>
                <span
                  >This report is not valid for Court of Law or medico-legal
                  purposes.</span
                >
              </div>
            </footer>
          </td>
        </table>
      </tfoot>
    </table>
    <template v-if="showReceiptCopies">
      <br />
      <br />
      <br />
    </template>
    <div v-if="showReceiptCopies" class="mt-4">
      <PrintTable
        v-for="i in 2"
        :key="i"
        :refferedTo="refferedTo.name"
        :searchResult="searchResult"
        :registerPatient="patient"
        :rows="rows"
        :total="charges"
        :discount="discount"
        :selectedPanel="selectedDiscountType"
        :invoiceNo="invoiceNo"
        :isOther="isOther"
        :branch_logo="branch_logo"
        :org_logo="org_logo"
        :invoiceType="invoiceType"
      />
    </div>
  </div>
</template>

<script>
import PrintTable from "./PrintTable.vue";
import moment from "moment";
import { mapGetters } from "vuex";
import prescriptionLogo from "@/assets/logo-print-3.png";
export default {
  props: {
    patient: {
      type: Object
    },
    searchResult: {
      type: Object
    },
    invoiceNo: {
      type: [Number, String]
    },
    refferedTo: {
      type: Object,
      default: () => {}
    },
    charges: {
      type: [String, Number],
      default: ""
    },
    discount: {
      type: [String, Number],
      default: ""
    },
    rows: {
      type: Array,
      default: () => []
    },
    isOther: {
      type: String,
      default: ""
    },
    selectedDiscountType: {
      type: String,
      default: ""
    },
    referredBy: {
      type: String,
      default: ""
    },
    branch_logo: {
      type: String,
      default: ""
    },
    org_logo: {
      type: String,
      default: ""
    },
    invoiceType: {
      type: String,
      default: ""
    },
    showReceiptCopies: {
      type: Boolean,
      default: true
    },
    patientGender: {
      type: String,
      default: ""
    }
  },
  components: {
    PrintTable
  },
  methods: {
    getGender(val) {
      if (val === undefined || val === null || val === "") return "";
      const normalized = String(val).toLowerCase();
      if (normalized === "male" || normalized === "m" || normalized === "1") {
        return "M";
      }
      if (normalized === "female" || normalized === "f" || normalized === "2") {
        return "F";
      }
      return "";
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "auth/userInfo",
      selectedBranch: "expenses/selectedBranch"
    }),
    tokens() {
      return this.$store.getters["receptionist/tokens"];
    },
    prescriptionLogo() {
      return (
        this.org_logo ||
        this.userInfo?.bussinessLogoUrl ||
        prescriptionLogo ||
        ""
      );
    },
    currentDate() {
      return moment().format("DD/MM/YYYY");
    },
    doctor() {
      const reffered =
        this?.refferedTo?.name || this?.searchResult?.user?.employ?.name;
      return reffered;
    },
    getBranchUrl() {
      const branch = this.branch_logo || this.selectedBranch;
      return typeof branch === "string" ? branch : "";
    },
    uniqueRows() {
      const uniqueServices = [];
      const rowMap = {};

      this.rows.forEach(row => {
        if (!rowMap[row.service]) {
          rowMap[row.service] = true;
          uniqueServices.push(row);
        }
      });

      return uniqueServices;
    },
    tokenServiceHeader() {
      const fromRows = this.uniqueRows?.[0]?.service;
      const fromTokens = this.tokens?.[0]?.serviceHead;
      const header = fromRows || fromTokens || "TOKEN";
      return header.replace(/^OPD\s*-\s*/i, "");
    },
    tokenNo() {
      const fromRows =
        this.uniqueRows?.[0]?.token ??
        this.rows?.[0]?.token ??
        this.rows?.[0]?.visits ??
        this.rows?.[0]?.tokenNo;
      const fromTokens =
        this.tokens?.[0]?.visits ??
        this.tokens?.[0]?.token ??
        this.tokens?.[0]?.tokenNo ??
        this.tokens?.[0]?.value;
      const token = fromRows ?? fromTokens;
      return token !== undefined && token !== null && token !== ""
        ? token
        : "-";
    }
  }
};
</script>

<style>
#externalInvoice {
  display: none;
}

body {
  font-family: "Nunito Sans", sans-serif;
  font-size: 11pt;
  margin: 0;
  padding: 0;
}

h1,
h2,
h3 {
  margin: 0;
  padding: 0;
}

table {
  width: 100%;
  position: relative;
  border-collapse: collapse;
}

table thead tr {
  width: 100%;
}

table thead tr td {
  width: 100%;
}

.table-body td {
  border-bottom: 1px solid #ccc;
}

.table-body h1 {
  font-style: italic;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.05em;
  color: #141414;
}

.table-body .content {
  width: 150px;
  text-align: center;
  border-right: 1px solid #ccc;
  height: calc(100vh - 25rem);
  padding: 0.5rem 1rem;
}

.table-body .content .treatment {
  text-align: left;
}

.table-body .content-space {
  padding: 0.5rem 1rem;
}

.header-wrrapper {
  text-align: center;
  margin: 0 auto;
}

.header-wrrapper h2 {
  font-weight: 900;
  font-size: 2.5rem;
  margin: 5px 0;
  color: #3c3e3d;
  text-transform: uppercase;
}

.header-wrrapper p {
  margin: 0;
}

.treatment {
  align-self: flex-end;
}

.treamtent-wrraper {
  height: 97%;
}

.externalInvoice thead tr .medical-record h2 {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.05em;
  color: #141414;
}

.externalInvoice thead tr .outpatient-details h2 {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.05em;
  color: #141414;
}

.header-wrrapper p {
  font-size: 1.2rem;
  font-style: italic;
  font-weight: 600;
  margin-top: 10px;
}

.header-wrrapper span {
  font-size: 1.2rem;
  font-style: italic;
  font-weight: 600;
  margin-top: 10px;
}

.header-wrrapper strong {
  margin-top: -5px;
  font-style: normal;
  font-weight: 600 !important;
  font-size: 1.1rem !important;
  line-height: 35px;
  color: #3e3e3e;
}

footer .message {
  margin-top: 20px;
  margin-bottom: 2rem !important;
}

footer .message p {
  margin: 0;
}

@media print {
  #externalInvoice {
    display: block !important;
  }

  @page {
    margin: 1cm;
  }

  thead {
    display: table-header-group;
  }

  tfoot {
    display: table-footer-group;
  }
}
</style>
